var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0C6.24643 0.00251976 4.08589 0.898862 2.49238 2.49238C0.898862 4.08589 0.00251976 6.24643 0 8.5C0.00377584 10.7532 0.900521 12.913 2.49376 14.5062C4.087 16.0995 6.24682 16.9962 8.5 17C10.7543 17 12.9163 16.1045 14.5104 14.5104C16.1045 12.9163 17 10.7543 17 8.5C17 6.24566 16.1045 4.08365 14.5104 2.48959C12.9163 0.895533 10.7543 0 8.5 0ZM13.67 13.4048C13.1927 12.442 12.4557 11.6317 11.5423 11.0653C10.6289 10.499 9.57541 10.1992 8.50069 10.1998C7.42597 10.2004 6.3728 10.5013 5.46 11.0685C4.54719 11.6358 3.81108 12.4469 3.33472 13.4103C2.06374 12.0921 1.35554 10.3311 1.36 8.5C1.36 6.60635 2.11225 4.79027 3.45126 3.45126C4.79027 2.11225 6.60635 1.36 8.5 1.36C10.3936 1.36 12.2097 2.11225 13.5487 3.45126C14.8878 4.79027 15.64 6.60635 15.64 8.5C15.6443 10.3285 14.9379 12.0872 13.67 13.4048ZM8.5 3.4C7.89479 3.4 7.30317 3.57947 6.79996 3.9157C6.29674 4.25194 5.90453 4.72985 5.67293 5.28899C5.44132 5.84813 5.38073 6.46339 5.4988 7.05698C5.61687 7.65056 5.9083 8.1958 6.33625 8.62375C6.7642 9.05169 7.30944 9.34313 7.90302 9.4612C8.4966 9.57927 9.11187 9.51868 9.67101 9.28707C10.2302 9.05547 10.7081 8.66326 11.0443 8.16004C11.3805 7.65683 11.56 7.06521 11.56 6.46C11.56 6.05816 11.4809 5.66024 11.3271 5.28899C11.1733 4.91773 10.9479 4.5804 10.6637 4.29625C10.3796 4.01211 10.0423 3.78671 9.67101 3.63293C9.29975 3.47915 8.90184 3.4 8.5 3.4Z",
    fill: "url(#paint0_linear_2068_62)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2068_62",
    x1: -1.40602,
    y1: 3.79464,
    x2: 20.7548,
    y2: 6.2696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA5332"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#DA5332"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78524"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.997cba54ba45b1b93eb7f7780bd6003a.svg";
export { ForwardRef as ReactComponent };